import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import UserPage from 'flarum/forum/components/UserPage';
import Signature from './Signature';
import ItemList from 'flarum/common/utils/ItemList';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
import SignatureState from '../states/SignatureState';
export default class SignaturePage extends UserPage {
  constructor() {
    super(...arguments);
    _defineProperty(this, "signatureState", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loadUser(m.route.param('username'));
    this.signatureState = new SignatureState();
  }
  content() {
    return m("div", {
      className: "SignaturePage"
    }, m("div", {
      className: "SignaturePage-controls"
    }, this.controlItems().toArray()), m(Signature, {
      user: this.user,
      state: this.signatureState
    }));
  }
  controlItems() {
    var _this$user;
    const items = new ItemList();
    ((_this$user = this.user) == null ? void 0 : _this$user.canEditSignature()) && items.add('edit', m(Button, {
      className: "Button",
      icon: "fas fa-edit",
      onclick: () => this.onEdit()
    }, app.translator.trans('signature.forum.buttons.edit')));
    return items;
  }
  onEdit() {
    this.signatureState.toggleEditing();
  }
}
flarum.reg.add('katosdev-signature', 'forum/components/SignaturePage', SignaturePage);